import axios from "axios";
import { getApiCaller, postApiCaller } from "../apiCaller";

export const getDashboardData = async () => {
    const response = await getApiCaller("dashboard/get");
    return response;
}

export const dashboardGraphData = async () => {
    const response = await getApiCaller("dashboard/visits-per-month");
    return response;
}


const getIpAddress = async () => {
    const response = await axios.get("https://api.ipify.org?format=json");
    return response.data.ip;
}

export const createChatSession = async () => {
    const ip = await getIpAddress();
    const body = {
        "metadata": {
            "ip": ip,
            "language": "en",
            "locale": "en-US",
            "user_id": "admin",
            "custom_field": "admin"
        }
    }
    const response = await postApiCaller("chat/session", body);
    return response; 
}

export const sendMessage = async (data) => {
    const ip = await getIpAddress();
    const payload = {
        "session_id": data?.session_id,
        "message": data?.message,
        "metadata": {
            "ip": ip,
        }
    }
    const response = await postApiCaller("chat/message", payload);
    return response;
}


export const chatHistory = async (sessionId) => {
    const response = await getApiCaller(`chat/history/${sessionId}`);
    return response;
}